/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Prospects_Estimatedticketsizemax4Inputs */

const en_coinvestments_prospects_estimatedticketsizemax4 = /** @type {(inputs: Coinvestments_Prospects_Estimatedticketsizemax4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est. Ticket Size Max.`)
};

/**
* | output |
* | --- |
* | "Est. Ticket Size Max." |
*
* @param {Coinvestments_Prospects_Estimatedticketsizemax4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_prospects_estimatedticketsizemax4 = /** @type {((inputs?: Coinvestments_Prospects_Estimatedticketsizemax4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Prospects_Estimatedticketsizemax4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_prospects_estimatedticketsizemax4(inputs)
});
export { coinvestments_prospects_estimatedticketsizemax4 as "coInvestments_prospects_estimatedTicketSizeMax" }